export default __webpack_public_path__ + "static/media/Basics.ce42c614.webp";